import React, {useEffect, useState} from "react";
import ReactQuill from "react-quill";
import {useParams} from "react-router-dom";
import {useSnackbar} from "notistack";
import {get} from "lodash"
import apis from "../services";
//Material UI Components
import {
    Avatar,
    Button,
    FormControlLabel,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    ListItemText,
    Popover,
    Radio,
    RadioGroup,
    Typography,
    useMediaQuery,
    useTheme
} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import ReplyIcon from "@material-ui/icons/Reply";
import SendIcon from "@material-ui/icons/Send";
import BufferBar from "../components/BufferBar";
import {useMutation, useQuery, useQueryClient} from "react-query";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AttachFileIcon from "@material-ui/icons/AttachFile";
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import ContactMailOutlinedIcon from '@material-ui/icons/ContactMailOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DrawerList from "../components/DrawerList";
import {SERVER_PATH} from "../assets/constants";
import {useSelector} from "react-redux";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: "1rem",
        backgroundColor: "#FFF",
        paddingLeft: '5em',
        [theme.breakpoints.down("xs")]: {
            paddingLeft: 0,
        }
    },
    subjectContainer: {
        marginBottom: '2em'
    },
    subject: {
        fontSize: '1rem'
    },
    label: {
        marginLeft: '1em',
        backgroundColor: theme.palette.primary.main,
        color: '#FFF',
        textTransform: "uppercase",
        padding: '.2em 1em'
    },
    messageAvatar: {
        marginLeft: '-4em',
        [theme.breakpoints.down("xs")]: {
            marginLeft: 0,
            marginRight: '1em'
        },
        marginRight: '1.5em'
    },
    userName: {
        fontWeight: 'bold'
    },
    messageContainer: {
        [theme.breakpoints.down("xs")]: {
            margin: '0 1em'
        }
    },
    editor: {
        '& .ql-toolbar.ql-snow': {
            border: 'none',
            backgroundColor: 'lightgray',
            borderBottom: '1px ridge',
            paddingLeft: '2em'
        },
        '& .ql-container.ql-snow': {
            border: 'none',
            height: '18em',
        },
        width: '100%'
    },
    paper: {
        width: 'inherit'
    },
    popoverContent: {
        overflow: 'hidden',
        textDecoration: 'none',
        fontWeight: 500,
        fontSize: '1rem',
        color: '#000'
    },
    button: {
        width: '15em'
    },
    attachments: {
        [theme.breakpoints.down("xs")]: {
            margin: '0 1em'
        }
    }
}));

const Message = ({history}) => {
    //Hooks
    const theme = useTheme();
    const {id} = useParams();
    const classes = useStyles();
    const queryClient = useQueryClient();
    const {enqueueSnackbar} = useSnackbar();
    const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));

    //States
    const [report, setReport] = useState('')
    const [anchorEl, setAnchorEl] = useState(null);
    const [readList, setReadList] = useState(false);
    const [sendList, setSendList] = useState(false);
    const [_anchorEl, _setAnchorEl] = useState(null);
    const [showReply, setShowReply] = useState(false);
    const [messageBody, setMessageBody] = useState('');

    const {logAccess, member_type} = useSelector(store => store.inbox)

    const {data, isLoading, refetch} = useQuery(['message', id], apis.messageApi);

    //Destructing Values
    const message = get(data, 'data.row', null);
    const replies = get(data, 'data.replies', []);
    const userList = get(data, 'data.user_list', []);

    const {sentList, previousPath} = history.location?.state || {};
    const accessStatus = ["Standard", "Basic"].includes(member_type) && message?.label === 'Verified' && previousPath !== 'sent'

    useEffect(() => {

        if(accessStatus)
            history.push('/verified')
    },[history,accessStatus]);

    const {mutate} = useMutation('send', apis.sendMessageApi, {
        onSuccess: async () => {
            enqueueSnackbar('Successfully message sent', {variant: 'success'});

            // TODO:: Invalidate Query not working
            await queryClient.invalidateQueries('message');
            await queryClient.invalidateQueries('labels');
        },
        onError: error => {
            enqueueSnackbar('Message sending failed', {variant: 'error'})
            console.log("ERROR: ", error);
        }
    });
    const {mutate: sendReport} = useMutation('report', apis.sendReportApi, {
        onSuccess: () => enqueueSnackbar("Report Successfully submitted", {variant: "success"}),
        onError: error => {
            console.log('ERRORS:', error);
            enqueueSnackbar("Report submit failed", {variant: "success"});
        }
    });
    const {data: sentListResponse, mutate: mutation, isLoading: loading} = useMutation('sent_list', apis.sendListApi);

    const handlePopover = (event) => setAnchorEl(anchorEl ? null : event.currentTarget);
    const _handlePopover = (event) => _setAnchorEl(_anchorEl ? null : event.currentTarget);
    const handleReadList = (open) => (event) => setReadList(open);
    const handleSendList = (open) => (event) => {
        setSendList(open);
        mutation(sentList);
    };
    const handleDownload = (file) => window.open(`${SERVER_PATH}${file}`);

    //Send Message
    const handleSend = async () => {
        if (!!messageBody) {
            enqueueSnackbar('Message Sending', {variant: 'info'});
            mutate({message: messageBody, msg_id: message.id});
            setShowReply(false);
        } else
            return enqueueSnackbar("Please Type Message", {variant: "warning"});
    };
    const handleSendReport = () => {
        sendReport({message_id: id, visitor_id: message?.from_id, status: report});
        _handlePopover();
        refetch();
    };

    const DownloadFiles = ({attachments}) => {
        if (attachments?.length) {
            return (
                <List className={classes.attachments}>
                    <Typography variant={'subtitle1'} style={{fontWeight: 'bold'}}>Attachments</Typography>
                    {
                        attachments?.map((path, index) => {
                            const label = path.split(/[/]+/).pop();
                            return (
                                <ListItem key={index} button onClick={() => handleDownload(path)}>
                                    <ListItemIcon><DescriptionOutlinedIcon/></ListItemIcon>
                                    <ListItemText id={label} primary={label}/>
                                    <ListItemSecondaryAction>
                                        <IconButton edge="start" aria-label="download" disableFocusRipple
                                                    onClick={() => handleDownload(path)}>
                                            <GetAppOutlinedIcon/>
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            )
                        })
                    }
                </List>
            )
        }
        return null;
    };

    const Conversation = ({name, date, message: msg, attachments}) => {
        let sender = name === message.display_name;
        return (
            <Grid container style={{margin: '2em 0'}}>
                {
                    sender ? (<>
                        <Grid item container direction={'row'} className={classes.testing}>
                            <Grid item className={classes.messageAvatar}>
                                <Avatar style={message?.color}>{message?.display_name[0]}</Avatar>
                            </Grid>
                            <Grid item sm container justify='space-between'>
                                <Grid item sm container direction='column'>
                                    <Grid item>
                                        <Typography
                                            className={classes.userName}> {message?.display_name} </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography>
                                            to me
                                            <IconButton size={"small"}>
                                                <ExpandMoreIcon/>
                                            </IconButton>
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item> {date} </Grid>
                            </Grid>
                            <Grid item container>
                                <DownloadFiles attachments={attachments}/>
                            </Grid>
                            <Grid item>
                                <Typography>{msg}</Typography>
                            </Grid>
                        </Grid>
                        <Grid item style={{marginTop: '2em'}}>
                            <Button component={"a"} href="#reply" variant={'outlined'} startIcon={<ReplyIcon/>}
                                    onClick={() => setShowReply(!showReply)}
                                    fullWidth={matchesXS}
                            >
                                Reply
                            </Button>
                        </Grid>
                    </>) : <Grid item container alignItems={"flex-end"} direction={'column'}>
                        <Grid item>
                            <Typography>Replied to {message?.display_name} @ {date}</Typography>
                        </Grid>
                        <Grid item className={classes.test}
                              style={{backgroundColor: 'rgba(0, 0,0,0.3)', padding: '1em', borderRadius: '1em'}}>
                            <Typography style={{color: '#FFF'}}>{msg}</Typography>
                        </Grid>
                    </Grid>
                }
            </Grid>
        )
    }

    //Reply Box
    const replyMessage = (
        <Grid container spacing={3} style={{backgroundColor: '', marginTop: 10}}>
            <Grid item container>
                <Grid item style={{marginLeft: '-3em', marginRight: '.5em'}}>
                    <Avatar style={message?.color}>{message?.display_name[0]}</Avatar>
                </Grid>
                <Grid item container
                      style={{height: "24em", backgroundColor: '', borderRadius: '1em', border: '1px dashed'}}>
                    <Grid item container alignItems='center' style={{borderBottom: '1px ridge'}}>
                        <IconButton>
                            <ReplyIcon/>
                        </IconButton>
                        <Typography>
                            {message?.display_name}
                        </Typography>
                    </Grid>
                    <ReactQuill
                        id='reply'
                        className={classes.editor}
                        style={{height: "20em", backgroundColor: ''}}
                        value={messageBody}
                        placeholder='write a message'
                        name="message"
                        onChange={(value) => setMessageBody(value)}
                    />
                </Grid>
                <Grid item container direction={'row'} justify={'flex-end'} alignItems={'center'}
                      style={{marginTop: '-5em', marginRight: '1em',}}>
                    <Grid item>
                        <IconButton size={"small"}>
                            <AttachFileIcon/>
                        </IconButton>
                    </Grid>
                    <Grid item>
                        <Button endIcon={<SendIcon/>} disableElevation color="primary" onClick={handleSend}>
                            Send
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );

    const InfoPopover = (
        <Popover id="popover" classes={{paper: classes.paper,}}
                 open={Boolean(anchorEl)} anchorEl={anchorEl}
                 anchorOrigin={{
                     vertical: 'bottom',
                     horizontal: 'center',
                 }}
                 transformOrigin={{
                     vertical: 'top',
                     horizontal: 'center',
                 }}
                 onClose={handlePopover}
        >
            <Grid container style={{padding: '1em'}}>
                <Grid item container direction={"column"} sm>
                    <Grid item container>
                        <Grid item sm={2}>
                            <Typography>
                                From:
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography style={{fontWeight: 'bold'}}>
                                {message?.display_name}〈{message?.from_email}〉
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item container>
                        <Grid item sm={2}>
                            <Typography>To:</Typography>
                        </Grid>
                        <Grid item>
                            <Typography>{message?.to_name}〈{message?.to_email}〉</Typography>
                        </Grid>
                    </Grid>
                    <Grid item container>
                        <Grid item sm={2}>
                            <Typography>
                                Date:
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography>
                                {message?.created}
                            </Typography></Grid>
                    </Grid>
                    <Grid item container>
                        <Grid item sm={2}>
                            <Typography>
                                Subject:
                            </Typography>
                        </Grid>
                        <Grid item sm style={{overflow: "hidden", textOverflow: "ellipsis", width: '25rem'}}>
                            <Typography noWrap>
                                {message?.subject}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Popover>
    )

    const reportPopover = (
        <Popover id="report_popover" classes={{paper: classes.paper,}}
                 open={Boolean(_anchorEl)} anchorEl={_anchorEl}
                 anchorOrigin={{
                     vertical: 'bottom',
                     horizontal: 'center',
                 }}
                 transformOrigin={{
                     vertical: 'top',
                     horizontal: 'center',
                 }}
                 onClose={_handlePopover}
        >
            <Grid item container style={{backgroundColor: '#00394d', borderRadius: 1, padding: '0em 3em'}}
                  justify={'center'}>
                <Typography variant={'subtitle1'}
                            style={{fontWeight: 'bold', color: '#FFF', textTransform: "uppercase"}}> Profile Status of
                    Anonymous </Typography>
            </Grid>
            <Grid container style={{padding: '0.5em'}}>
                <Grid item container direction={"column"} sm spacing={2}>
                    <Grid item container>
                        <Grid item sm={5}>
                            <Typography>
                                Full Name:
                            </Typography>
                        </Grid>
                        <Grid item sm>
                            <Typography style={{fontWeight: 'bold'}}>
                                {message?.first_name}{message?.last_name}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item container>
                        <Grid item sm={5}>
                            <Typography>Designation:</Typography>
                        </Grid>
                        <Grid item sm>
                            <Typography>{message?.designation}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item container>
                        <Grid item sm={5}>
                            <Typography>
                                Company Name:
                            </Typography>
                        </Grid>
                        <Grid item sm>
                            <Typography>
                                {message?.company_name}
                            </Typography></Grid>
                    </Grid>
                    <Grid item container>
                        <Grid item sm={5}>
                            <Typography>
                                Report User:
                            </Typography>
                        </Grid>
                        {
                            message?.report
                                ? (<Grid item sm>
                                    <Typography>
                                        SPAM
                                    </Typography>
                                </Grid>)
                                : (<>
                                    <Grid item>
                                        <RadioGroup row value={report} onChange={(e) => setReport(e.target.value)}>
                                            <FormControlLabel control={<Radio/>} value="Spam" label='Spam'/>
                                            <FormControlLabel control={<Radio/>} value="Seller" label='Seller'/>
                                            <FormControlLabel control={<Radio/>} value="Buyer" label='Buyer'/>
                                            <FormControlLabel control={<Radio/>} value="Marketing" label='Marketing'/>
                                        </RadioGroup>
                                    </Grid>
                                    <Grid item container justify={"center"}>
                                        <Button variant='outlined' onClick={handleSendReport}> Submit </Button>
                                    </Grid>
                                </>)
                        }
                    </Grid>
                </Grid>
            </Grid>
        </Popover>
    )

    //Main Return
    return (
        <Grid container>
            {isLoading ? <Grid item container justify='center'> <BufferBar/></Grid>
                : <Grid className={classes.root} item container direction="column">
                    <Grid item container className={classes.subjectContainer} alignItems={'center'}>
                        <Grid item>
                            <Typography className={classes.subject} variant={"h6"}>
                                {message?.subject}
                            </Typography>
                        </Grid>
                        <Grid item container={matchesXS} justify={matchesXS ? 'center' : undefined}>
                            <Typography className={classes.label}>
                                {message?.label}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item container direction={'row'}>
                        <Grid item sm container justify='space-between'
                              style={{flexWrap: 'nowrap', backgroundColor: ''}}>
                            <Grid item className={classes.messageAvatar}>
                                <Avatar style={message?.color}>{!sentList ? message?.display_name[0] : null}</Avatar>
                            </Grid>
                            {
                                !sentList ? (<>
                                        <Grid item sm container direction='column'>
                                            <Grid item>
                                                  <Typography
                                                      href={`${URL}/${message?.slug}`}
                                                      component={'a'}
                                                      target="_blank"
                                                      style={{  color: '#000' }}
                                                      className={classes.userName}> {message?.display_name} </Typography>
                                                      </Grid>
                                                      <Grid item>
                                                      <Typography>
                                                      to me
                                                      <IconButton size={"small"}
                                                      onClick={handlePopover}>
                                                      <ExpandMoreIcon/>
                                                      </IconButton>
                                                      </Typography>
                                                      </Grid>
                                                      </Grid>
                                                      </>)
                                                      : <Grid item>
                                                      <Button
                                                      className={classes.button}
                                                      endIcon={<ContactMailOutlinedIcon/>}
                                                      variant={"outlined"}
                                                      size={'medium'}
                                                      onClick={handleSendList(true)}
                                                      >
                                                      Member List
                                                      </Button>
                                                      </Grid>
                                                  }

                            <Grid item container sm direction={'column'} alignItems={'flex-end'} spacing={2}>
                                <Grid item container justify='flex-end' align={'center'} spacing={2}>
                                    {
                                        /* Show Button only in Sent Tab */
                                        previousPath === 'sent'
                                        && logAccess.includes(member_type)
                                        && (<Grid item>
                                            <Button
                                                variant={"outlined"}
                                                onClick={handleReadList(true)}
                                                startIcon={<VisibilityIcon/>}
                                            >
                                                Message Read By &nbsp;<b>{userList && userList.length} </b>
                                            </Button>
                                        </Grid>)

                                    }
                                    {
                                        /* Show Button only in Anonymous Tab */
                                        previousPath === 'anonymous' && (
                                            <Grid item>
                                                <Button startIcon={<AssignmentIndOutlinedIcon/>} variant={"outlined"}
                                                        onClick={_handlePopover}
                                                >
                                                    Profile Status
                                                </Button>
                                            </Grid>
                                        )
                                    }
                                </Grid>
                                <Grid item>
                                    <Typography>
                                        {message?.created}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item className={classes.messageContainer}>
                        <Typography align={'justify'} dangerouslySetInnerHTML={{__html: message?.message}}/>
                    </Grid>
                    <Grid item container direction={'column'}>
                        <Grid item>
                            <DownloadFiles attachments={message?.attachments}/>
                        </Grid>
                        <Grid item style={{marginTop: '2em'}}>
                            <Button component={"a"} href="#reply" variant={'outlined'} startIcon={<ReplyIcon/>}
                                    onClick={() => setShowReply(!showReply)}
                                    fullWidth={matchesXS}
                            >
                                Reply
                            </Button>
                        </Grid>
                    </Grid>

                    {/*Reply*/}
                    {replies?.length > 0 && replies?.map((msg, i) =>
                        <Conversation key={i} name={msg.display_name} date={msg.created}
                                      message={<Typography dangerouslySetInnerHTML={{__html: msg.message}}/>}
                                      attachments={msg?.attachments}
                        />)}
                    {showReply && replyMessage}
                </Grid>}
            <DrawerList open={readList} close={handleReadList(false)} list={userList}/>
            <DrawerList open={sendList} close={handleSendList(false)} list={sentListResponse?.data} loading={loading}/>
            {InfoPopover}
            {reportPopover}
        </Grid>
    );
};

export default Message;
